// Dependecies
import React from 'react';
import PropTypes from 'prop-types';

function Loading(props) {
  const { text } = props;
  return (
    <div className="spinner-main" {...props}>
      <div className="spinner-second">
        <div className="spinner"> </div>
        <p className="">{text}</p>
      </div>
    </div>
  );
}

Loading.propTypes = {
  text: PropTypes.string,
};

Loading.defaultProps = {
  text: '',
};

export default Loading;
